import React from 'react';

const SurveyAnswerActivities = ({recentData}) => {
    const {image, title, color, borderColor, clickEvent} = recentData;
    return (
        <div className="media survey-list-line" onClick={clickEvent}>
            <div
                className={`border-${borderColor} bg-white icon-btn user-avatar size-40 z-index-20 align-item-self mr-3`}>
                <i className={`zmdi zmdi-${image} text-${color} zmdi-hc-fw`}/>
            </div>
            <div className="media-body">
                <h4>{title}</h4>
            </div>
        </div>
    );
};

export default SurveyAnswerActivities;


// WEBPACK FOOTER //
// ./components/dashboard/Common/SurveyAnswerActivities/index.js